import { TypeColumnWithoutUnresolvableLinksResponse } from 'contentful-types'

import { BlockRenderer } from '../../../renderer/contentful/BlockRenderer'
import { withContentful } from '../../../renderer/contentful/withContentful'

import Column, { ColumnProps } from './Column'

const ContentfulColumn = withContentful<TypeColumnWithoutUnresolvableLinksResponse['fields'], ColumnProps>(Column, {
  id: (props) => props.fields.sectionId,
  children: (props) => {
    return <BlockRenderer block={props.fields?.components} fieldPath={'.components'} />
  },
  horizontalAlign: (props) => {
    return {
      xs: props.fields?.horizontalAlign?.toLowerCase() as Lowercase<
        TypeColumnWithoutUnresolvableLinksResponse['fields']['horizontalAlign']
      >,
      sm: props.fields?.smHorizontalAlign?.toLowerCase() as Lowercase<
        TypeColumnWithoutUnresolvableLinksResponse['fields']['horizontalAlign']
      >,
      md: props.fields?.mdHorizontalAlign?.toLowerCase() as Lowercase<
        TypeColumnWithoutUnresolvableLinksResponse['fields']['horizontalAlign']
      >,
      lg: props.fields?.lgHorizontalAlign?.toLowerCase() as Lowercase<
        TypeColumnWithoutUnresolvableLinksResponse['fields']['horizontalAlign']
      >,
      xl: props.fields?.xlHorizontalAlign?.toLowerCase() as Lowercase<
        TypeColumnWithoutUnresolvableLinksResponse['fields']['horizontalAlign']
      >,
    }
  },
})

export default ContentfulColumn
